<template>
    <form-container :headerText="title" :width="400" action="editSaisonTeams"
                    :valid-actions="['editSaisonTeams']" @save="save()">
        <div v-if="rules" class="px-7 pb-3">
            <v-autocomplete v-if="this.lvId===1" class="mt-3" v-model="lvIdSelected"
                            :disabled="vereinBlockedForChanges"
                            item-value="id" item-text="nameShort" no-data-text="keine Daten gefunden"
                            :items="landesverbaende" dense label="Bitte Landesverband wählen">
            </v-autocomplete>
            <v-autocomplete :disabled="!landesverband || vereinBlockedForChanges"
                    class="mt-3" v-model="dataObject.vereinsNr" :rules="[rules.required]"
                    :items="items" dense label="Verein" @change="setMannschaftsname()"></v-autocomplete>
            <v-text-field v-model="dataObject.name" :rules="[rules.required]"
                          label="Mannschaftsname">
            </v-text-field>
            <error-msg :error="error"></error-msg>
            <!--<p>dataObject: {{dataObject}}</p>
            <p>currentData: {{currentData}}</p>
            <p>saison: {{saison}}</p>-->
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "../../components/form/formContainer";
    import {FormRules} from "../../services/formRules";
    import ErrorMsg from "../../components/elements/errorMsg";
    import {SaisonTeam} from "../../services/data/saisonTeam";
    import {Landesverband} from "../../services/data/landesverband";
    import { db } from '../../services/db'

    export default {
        components: { ErrorMsg, FormContainer},
        name: "saison-teams-edit",
        props: ['currentData', 'saison'],
        data: () => ({
            rules: null,
            dataObject: null,
            error: '',
            landesverband: null,
            lvIdSelected: null,
        }),
        computed: {
            vereinBlockedForChanges(){
                if ( this.dataObject.id ) {
                    return this.saison.teamHasAlreadyPlayed(this.dataObject.id);
                } else {
                    return false;
                }
            },
            title(){ return this.currentData ? 'Team ändern' : 'Team anlegen' },
            lvId(){ return parseInt(this.$route.query.itemId.split('_')[0]); },
            items(){ return this.landesverband ?
                            this.landesverband.getVereinsListForAutoComplete() : []; },
            landesverbaende(){
                const list = this.$store.state.local.landesverbaende
                    .filter(lv => parseInt(lv.id) < 20 );
                list.push( this.$store.state.local.nationaleLigen);
                list.sort((a, b) => a.nameShort > b.nameShort ? 1 : -1);
                return list;
            }
        },
        created(){
            this.rules = new FormRules();
            this.dataObject = new SaisonTeam();
            if ( this.currentData ) {
                this.dataObject.setFromDataObject(this.currentData);
                this.lvIdSelected = this.currentData.lvId;
            }
            if ( this.lvId !== 1 ) {
                if ( this.$store.state.realtime.landesverbaende[this.lvId] ) {
                    this.setLandesverband(this.$store.state.realtime.landesverbaende[this.lvId]);
                }
            }
        },
        methods: {
            setLandesverband(dataObject){
                this.landesverband = new Landesverband();
                this.landesverband.setFromDataObject( dataObject );
            },
            setMannschaftsname(){
                this.dataObject.vereinsName = this.landesverband.getVereinsNameById(this.dataObject.vereinsNr);
                if ( !this.dataObject.name || this.dataObject.name.indexOf(this.dataObject.vereinsName) === -1
                    ) {
                    this.dataObject.name = this.landesverband.getVereinsNameById(this.dataObject.vereinsNr)
                }
            },
            async save(){
            // check for name duplicates
                if ( this.saison.isTeamNameDuplicate(this.dataObject.name) ) {
                    this.error = 'Dieser Mannschaftsname ist in dieser Liga bereits vergeben!';
                    return;
                }
            // get id
                if ( !this.currentData ) {
                    this.dataObject.id = this.saison.getNextTeamId();
                } else {
                    this.dataObject.id = this.currentData.id;
                }
            // setlvId
                this.dataObject.lvId = this.landesverband.id;
            // save data
                if ( (this.currentData && this.dataObject.setDocumentUpdates(this.currentData)) ||
                     !this.currentData ) {
                    if ( this.currentData && this.currentData.id  ) {
                        this.saison.local.documentUpdates = {
                            ['teams.' + this.dataObject.id + '.name']: this.dataObject.getDbObject().name,
                        };
                    } else {
                        this.saison.local.documentUpdates = {
                            ['teams.' + this.dataObject.id]: this.dataObject.getDbObject(),
                        };
                    }
                    this.$store.state.local.loader = true;
                    let reply = await this.saison.saveEdited('saison_edit');
                    if ( reply.successful ) {
                        if ( this.dataObject.id ) {
                            this.saison.updateTeamData(this.dataObject.id, this.lvIdSelected + this.dataObject.vereinsNr)
                        } else {
                            this.$store.state.local.loader = false;
                            window.history.back();
                        }
                    } else {
                        this.error = this.dataObject.getDBErrorText(reply.content);
                    }
                } else {
                    window.history.back();
                }
            },
            setVereineFromLandesverband(){
                // needed for nationwide ligen
                db.collection("landesverbaende").doc(this.lvIdSelected).get()
                .then((doc) => {
                    if (doc.exists) {
                        let dataObject = doc.data();
                        dataObject.id = doc.id;
                        this.setLandesverband(dataObject);
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                    }
                }).catch((error) => {
                    console.log("Error getting document:", error);
                });
            }
        },
        watch: {
            lvIdSelected(){
                this.setVereineFromLandesverband();
            }
        }
    }
</script>

<style scoped>

</style>